module.exports = __webpack_public_path__ + "static/media/file.7681dc45.svg";